import { useCallback } from 'react';
import { useTranslation } from '../../../i18n/LanguageContext';

/**
 * Texts of Maaş Ödemeleri (`salaryPayment.*`). `formatMoney` shows amounts
 * in ₺ in the UI language, `formatPeriod` turns '2026-10' into "Ekim 2026".
 * The Excel file keeps its Turkish layout.
 */
const useSalaryPaymentText = () => {
  const { t, language, locale } = useTranslation();
  const label = useCallback((key, vars) => t(`salaryPayment.${key}`, vars), [t]);
  const formatMoney = useCallback((value) => {
    const number = Number(value);
    return `${(Number.isFinite(number) ? number : 0).toLocaleString(locale, { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ₺`;
  }, [locale]);
  const formatDate = useCallback((value) => {
    if (!value) return '';
    const date = new Date(value);
    return Number.isNaN(date.getTime()) ? String(value) : date.toLocaleDateString(locale);
  }, [locale]);
  const formatPeriod = useCallback((yearMonth) => {
    const [year, month] = String(yearMonth || '').split('-').map(Number);
    if (!year || !month) return String(yearMonth || '');
    return new Date(year, month - 1, 1).toLocaleDateString(locale, { month: 'long', year: 'numeric' });
  }, [locale]);
  return { t, language, locale, label, formatMoney, formatDate, formatPeriod };
};

export default useSalaryPaymentText;
